document.addEventListener('DOMContentLoaded', function() {
  // Solo ejecutar si no hay filtros aplicados en la URL
  const urlParams = new URLSearchParams(window.location.search);
  const hasFilters = urlParams.has('filter.v.availability');
  
  if (!hasFilters && window.location.pathname.includes('/collections/')) {
    const stockCheckbox = document.querySelector('input[name="filter.v.availability"][value="1"]');
    if (stockCheckbox && !stockCheckbox.checked) {
      stockCheckbox.click();
    }
  }
});
